import axios from "axios";
import config from "./config";
// import notify from './notify';
import { getAccessRefreshToken, getRefreshToken } from "../auth";
import { getRefreshTokenAndEmail, setToken } from "../../authService";

const instance = axios.create({
  baseURL: config.apiUrl,
});

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response } = error;
    let errorMessage = "Something went wrong!";

    if (response) {
      if (response?.data && response?.data?.error) {
        errorMessage = response?.data?.message
          ? response?.data?.message
          : response?.data?.error;
      }

      if (response.status === 401) {
        //response.status === 403 ||

        const payload = getRefreshTokenAndEmail();

        const refreshToken = await getAccessRefreshToken(payload);
        if (refreshToken) {
          setToken(refreshToken.accessToken, refreshToken.refreshToken);
          window.location.reload();
        }
      }
    }

    return Promise.reject(response);
  }
);

export default instance;
